export const THERAPIST_PROFILE_PICTURE_FOLDER_ON_S3 = 'profile-picture/therapists';
